import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Loading state management (will be set by setupLoadingInterceptor)
let showLoadingFn = null;
let hideLoadingFn = null;

// Setup loading interceptor with context functions
export const setupLoadingInterceptor = (showLoading, hideLoading) => {
  showLoadingFn = showLoading;
  hideLoadingFn = hideLoading;
};

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Show loading spinner
    if (showLoadingFn) {
      showLoadingFn('Processing...');
    }

    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Hide loading spinner on error
    if (hideLoadingFn) {
      hideLoadingFn();
    }
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // Hide loading spinner on success
    if (hideLoadingFn) {
      hideLoadingFn();
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Handle token expiration
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');

        if (!refreshToken) {
          throw new Error('No refresh token available');
        }

        const response = await axios.post(`${API_URL}/auth/refresh`, {
          refreshToken,
        });

        const { token, refreshToken: newRefreshToken } = response.data.data;
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', newRefreshToken);

        originalRequest.headers.Authorization = `Bearer ${token}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh failed, logout user
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');

        // Hide loading spinner
        if (hideLoadingFn) {
          hideLoadingFn();
        }

        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    // Hide loading spinner on error
    if (hideLoadingFn) {
      hideLoadingFn();
    }

    return Promise.reject(error);
  }
);

export default api;
